import React from 'react';
import PropTypes from 'prop-types';
import { CurrencyInput, SingleSelectionGroup } from '@paypalcorp/pp-react';

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function AmountCondensed(props) {
  var currencyCode = props.currencyCode,
    handleAmount = props.handleAmount,
    amount = props.amount,
    symbol = props.symbol,
    showValidationError = props.showValidationError,
    validationErrorMessage = props.validationErrorMessage,
    placeholder = props.placeholder;
  var handleAccept = function handleAccept(value, unmaskedValue) {
    handleAmount(unmaskedValue);
  };
  return /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "otherAmount",
    name: "donationAmount",
    id: "currencyAmount",
    "data-testid": "currencyAmount",
    autoComplete: "off",
    label: placeholder,
    value: amount,
    onAccept: handleAccept,
    currencyType: currencyCode,
    prefix: symbol,
    suffix: currencyCode,
    errorText: showValidationError && validationErrorMessage
  });
}
AmountCondensed.propTypes = {
  amount: PropTypes.string,
  symbol: PropTypes.string,
  currencyCode: PropTypes.string,
  handleAmount: PropTypes.func,
  showValidationError: PropTypes.bool,
  validationErrorMessage: PropTypes.string,
  placeholder: PropTypes.string
};

function determineLongestAmount(presetOptions) {
  var _presetOptions$filter, _longestOption$label;
  var longestOption = presetOptions === null || presetOptions === void 0 || (_presetOptions$filter = presetOptions.filter(function (option) {
    return (option === null || option === void 0 ? void 0 : option.label) !== undefined;
  })) === null || _presetOptions$filter === void 0 ? void 0 : _presetOptions$filter.reduce(function (a, b) {
    var _a$label, _b$label;
    return ((_a$label = a.label) === null || _a$label === void 0 ? void 0 : _a$label.length) > ((_b$label = b.label) === null || _b$label === void 0 ? void 0 : _b$label.length) ? a : b;
  }, 0);
  return longestOption === null || longestOption === void 0 || (_longestOption$label = longestOption.label) === null || _longestOption$label === void 0 ? void 0 : _longestOption$label.length;
}

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_selection_disabled__-zpMH:nth-child(1n) > fieldset label:hover {\n  border-color: #ffffff;\n  cursor: inherit;\n}\n.styles-module_single_selection_group_wrapper__f6Y6v {\n  width: 100%;\n}\n.styles-module_single_selection_group_wrapper__f6Y6v:nth-child(1n) > fieldset label {\n  flex: 1;\n  padding: 5px !important;\n}\n.styles-module_single_selection_group_wrapper__f6Y6v:nth-child(1n)\n  > fieldset\n  div[class*='ppvx_selection-group__buttons'] {\n  min-width: 44px !important;\n}\n\n.styles-module_normal_desktop_boxes__F-zcF:nth-child(1n) > fieldset label {\n  min-width: 100px;\n  max-width: 30%;\n}\n\n@media only screen and (max-width: 467px) {\n  .styles-module_normal_desktop_boxes__F-zcF:nth-child(1n) > fieldset {\n    width: 100%;\n  }\n}\n@media only screen and (max-width: 355px) {\n  .styles-module_normal_desktop_boxes__F-zcF:nth-child(1n) > fieldset {\n    width: auto;\n  }\n  .styles-module_normal_desktop_boxes__F-zcF:nth-child(1n) > fieldset label {\n    max-width: none;\n  }\n}\n.styles-module_max_desktop_boxes__pUsNL:nth-child(1n) > fieldset label {\n  min-width: 122px;\n  max-width: 31%;\n}\n@media only screen and (max-width: 421px) {\n  .styles-module_max_desktop_boxes__pUsNL:nth-child(1n) > fieldset label {\n    max-width: none;\n  }\n}\n.styles-module_mobile_preview_small_boxes__QuDTa:nth-child(1n) > fieldset label {\n  min-width: 20%;\n  max-width: 29%;\n}\n.styles-module_mobile_preview_large_boxes__KqZaX:nth-child(1n) > fieldset label {\n  min-width: 30%;\n}\n\n.styles-module_mobile_preview_max_boxes__tQnVY:nth-child(1n) > fieldset label {\n  min-width: 45%;\n}\n";
var styles = {"selection_disabled":"styles-module_selection_disabled__-zpMH","single_selection_group_wrapper":"styles-module_single_selection_group_wrapper__f6Y6v","normal_desktop_boxes":"styles-module_normal_desktop_boxes__F-zcF","max_desktop_boxes":"styles-module_max_desktop_boxes__pUsNL","mobile_preview_small_boxes":"styles-module_mobile_preview_small_boxes__QuDTa","mobile_preview_large_boxes":"styles-module_mobile_preview_large_boxes__KqZaX","mobile_preview_max_boxes":"styles-module_mobile_preview_max_boxes__tQnVY"};
styleInject(css_248z);

function PresetAmounts(_ref) {
  var presetOptions = _ref.presetOptions,
    selectedOption = _ref.selectedOption,
    handlePresetAmountClick = _ref.handlePresetAmountClick,
    showOtherAmount = _ref.showOtherAmount,
    amountFieldValue = _ref.amountFieldValue,
    isMobilePreview = _ref.isMobilePreview,
    charityAmountSymbol = _ref.charityAmountSymbol,
    charityAmountCode = _ref.charityAmountCode,
    showValidationError = _ref.showValidationError,
    messages = _ref.messages,
    handleAmountChange = _ref.handleAmountChange,
    isPreview = _ref.isPreview;
  var longestAmount = determineLongestAmount(presetOptions);
  var boxWidth = '';
  boxWidth = longestAmount > 10 ? 'max' : 'large';
  boxWidth = longestAmount < 6 ? 'small' : boxWidth;
  var smallWidthBoxes = boxWidth === 'small';
  var largeWidthBoxes = boxWidth === 'large';
  var maxWidthBoxes = boxWidth === 'max';
  var selectionGroupWrapperClassnames = clsx(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.single_selection_group_wrapper, true), styles.normal_desktop_boxes, !isMobilePreview && (largeWidthBoxes || smallWidthBoxes)), styles.max_desktop_boxes, !isMobilePreview && maxWidthBoxes), styles.mobile_preview_small_boxes, isMobilePreview && smallWidthBoxes), styles.mobile_preview_large_boxes, isMobilePreview && largeWidthBoxes), styles.mobile_preview_max_boxes, isMobilePreview && maxWidthBoxes), styles.selection_disabled, isPreview ? true : false));
  var errorText = showOtherAmount ? '' : showValidationError && messages.validationErrorMessage;
  var handleChange = function handleChange(event) {
    handlePresetAmountClick(event.target.value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: selectionGroupWrapperClassnames
  }, /*#__PURE__*/React.createElement(SingleSelectionGroup, {
    name: "preset-amounts",
    options: presetOptions,
    value: selectedOption,
    onChange: handleChange,
    errorText: errorText,
    align: "justify",
    hideLabel: true,
    disabled: isPreview ? true : false
  }), showOtherAmount && /*#__PURE__*/React.createElement(AmountCondensed, {
    amount: amountFieldValue,
    symbol: charityAmountSymbol,
    currencyCode: charityAmountCode,
    handleAmount: handleAmountChange,
    showValidationError: showValidationError,
    validationErrorMessage: messages.validationErrorMessage,
    placeholder: messages.placeholderOtherAmount
  }));
}
PresetAmounts.propTypes = {
  presetOptions: PropTypes.array,
  selectedOption: PropTypes.string,
  handlePresetAmountClick: PropTypes.func,
  showOtherAmount: PropTypes.bool,
  amountFieldValue: PropTypes.string,
  isMobilePreview: PropTypes.bool,
  charityAmountSymbol: PropTypes.string,
  charityAmountCode: PropTypes.string,
  showValidationError: PropTypes.bool,
  messages: PropTypes.object,
  handleAmountChange: PropTypes.func,
  isPreview: PropTypes.bool
};

export { PresetAmounts };
